<script setup>
import ArticleCard from "./components/ArticleCard.vue";
import ArticleSetCard from "./components/ArticleSetCard.vue";
import ServiceCard from "./components/ServiceCard.vue";

import {useProductStore} from "./stores/ProductStore";
import {useCartStore} from "./stores/CartStore";
import AppFullscreenModal from "./components/AppFullscreenModal.vue";
import ArticleDetailWidget from "./components/ArticleDetailWidget.vue";
import ArticleSetDetailWidget from "./components/ArticleSetDetailWidget.vue";
import ServiceDetailWidget from "./components/ServiceDetailWidget.vue";

import {modalStore} from "./stores/ModalStore";
import ToastComponent from "./components/ToastComponent.vue";

const productStore = useProductStore();
const cartStore = useCartStore();

const currentUrl = window.location.pathname;
productStore.fill(currentUrl);
</script>

<template>
    <ToastComponent v-if="modalStore.isOpened === false">
    </ToastComponent>
    <!--
    <div class="container-fluid dark-border mt-3 mb-3">
          <div class="container">
              <div class="row">
                  <div class="col">
                      Filter
                </div>
            </div>
        </div>
    </div>
    -->
    <div class="container">
        <div class="row" v-if="productStore.products.articles">
            <!-- Show Articles -->
            <ArticleCard
                v-for="article in productStore.products.articles"
                :key="article.id"
                :article="article"
                :category="productStore.products.category"
                @addToCart="cartStore.addArticles($event, article)">
            </ArticleCard>
        </div>

        <div class="row" v-if="productStore.products.articleSets">
            <!-- Show Articlesets -->
            <ArticleSetCard
                v-for="articleSet in productStore.products.articleSets"
                :key="articleSet.id"
                :articleSet="articleSet"
                @addToCart="cartStore.addArticleSets($event, articleSet)"
            />
        </div>

        <div class="row" v-if="productStore.products.services">
            <!-- Show Services -->
            <ServiceCard
                v-for="service in productStore.products.services"
                :key="service.id"
                :service="service"
                :category="productStore.products.category"
                @addToCart="cartStore.addService($event, service)">
            </ServiceCard>
        </div>
    </div>
    <AppFullscreenModal>
        <ArticleDetailWidget v-if="modalStore.isOpened && modalStore.article"
        ></ArticleDetailWidget>
        <ArticleSetDetailWidget v-if="modalStore.isOpened && modalStore.articleSet"
        ></ArticleSetDetailWidget>
        <ServiceDetailWidget v-if="modalStore.isOpened && modalStore.service"
        ></ServiceDetailWidget>
    </AppFullscreenModal>
</template>
